import { Component, OnInit } from '@angular/core';
import { TabName } from '../../../models/_enum-collections';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { SpecialInvestmentTableComponent } from '../../shared/special-investment-table/special-investment-table.component';

@Component({
  selector: 'app-invoice-queue',
  templateUrl: './invoice-queue.component.html',
  styleUrls: ['./invoice-queue.component.scss'],
  standalone: true,
  imports: [SpecialInvestmentTableComponent]
})
export class InvoiceQueueComponent implements OnInit {
  tabName!: number;
  prevDocumentType!: string;

  ngOnInit() {
    this.tabName = TabName.InvoiceDocReview;
    this.prevDocumentType = PreviewDocumentTypes.poeinvoice;
  }
}
